import styled from "styled-components";

export const PeriodLabel = styled.div`
  margin-bottom: 10px;
  h5 {
    font-size: 18px;
  }
`;